import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { AiOutlineCheckCircle, AiOutlineCloudUpload } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import "./drag-drop.css";
import tooltipStyles from "./../tooltip.module.css";
import { pagoniTest } from "helper/helper";

//const DragNdrop = ({ onFilesSelected, width, height }) => {
const DragNdrop = forwardRef((props, ref) => {
  //  useTraceUpdate(props, "DragNdrop");

  const { onFilesSelected, width, height, initialImages } = props;

  const MAX_FILE_SIZE = 5242880;
  const [files, setFiles] = useState([]); //useState<File[]>([]);
  const fileInputRef = useRef();

  const filesRef = React.useRef([]); //null);

  //
  const initState = {
    newAttribs: props,
  };

  const [state, setState] = useState(initState);

  //const [initImages, setState] = useState(images)

  useEffect(() => {
    if (props.images === state.newAttribs.images) {
      return;
    }
    setState({ ...state, newAttribs: props });

    //setFiles(props.images);
    //  filesRef.current = props.images;
    filesRef.current = [];
    filterFiles(props.images, false);
  }, [props]);

  useEffect(() => {
    /*  setFiles(...images);
    filesRef.current = images;
    filterFiles(images, false);*/
  }, []);
  //

  useImperativeHandle(ref, () => ({
    selectedFiles: () => {
      return files;
    },
    setSelectedFiles: (newFiles) => {
      const updatedFiles = [];
      setFiles(updatedFiles);
      filesRef.current = updatedFiles;
      filterFiles(newFiles, false);
    },
  }));

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles && selectedFiles.length > 0) {
      const newFiles = Array.from(selectedFiles);
      filterFiles(newFiles, true);
    }
  };
  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      //setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      filterFiles(newFiles, true);
    }
  };

  const fileToCache = (file, isLocal = false) => {
    if (isLocal === false) {
      return { file, cached: file, isLocal };
    }
    return { file, cached: URL.createObjectURL(file), isLocal };
  };

  const filterFiles = (newFiles, isLocal) => {
    const cachedNewFiles = newFiles.map((file) => fileToCache(file, isLocal));

    const MAX_FILE_SIZE = 4;
    let wholeFiles = [...filesRef.current, ...cachedNewFiles];
    const size =
      wholeFiles.length > MAX_FILE_SIZE ? MAX_FILE_SIZE : wholeFiles.length;
    wholeFiles = wholeFiles.slice(0, size);
    setFiles(wholeFiles);
    filesRef.current = wholeFiles;
  };

  const handleRemoveFile = (index) => {
    //setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setFiles((prevFiles) => {
      let newFiles = prevFiles.filter((_, i) => i !== index);
      filesRef.current = newFiles;

      return newFiles;
    });
  };

  // On file upload (click the upload button)
  const onFileUpload = async () => {
    // Create an object of formData
    const formData = new FormData();

    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      formData.append("ProductName", Date.now().toString());
      formData.append("ImageFile" /*Date.now().toString()*/, file, file.name);

      formData.append(
        "JsonData",
        `{ "Id": 123, "Nombre": "Dummy Description", "CreditoMinimo": 1234.33, "CreditoMaximo": 76.43, "Activo": true }`,
        //`{ "name": "Dummy Name", "description": "Dummy Description" }`
      );
    }

    const data = JSON.stringify({
      description: "description",
    });
    // const fd = new FormData();
    // append directly as part of the postData in plain text
    //--formData.append("data", data);

    // Update the formData object
    /*formData.append(
      "json",
      this.state.selectedFile,
      this.state.selectedFile.name
    );*/

    // Details of the uploaded file
    //console.log(this.state.selectedFile);

    // Request made to the backend api
    // Send formData object
    /*let posi = await axios.post("/api/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });*/
    pagoniTest(formData);

    //
    /*const formData1 = new FormData();

    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      formData1.append(
        "productToAdd[" + index + "].ProductName",
        Date.now().toString()
      );
      formData1.append(
        "productToAdd[" + index + "].ImageFile",
        file,
        file.name
      );*/

    /* formData1.append(
        "JsonData",
        `{ "Id": 123, "Nombre": "Dummy Description", "CreditoMinimo": 1234.33, "CreditoMaximo": 76.43, "Activo": true }`
        //`{ "name": "Dummy Name", "description": "Dummy Description" }`
      );*/

    //pagoniTest22(formData1);
    //}
    //

    console.log("");
  };

  useEffect(() => {
    //DESCOMENTAR onFilesSelected(files);
  }, [files, onFilesSelected]);

  function saveAddress(event) {
    console.log("-->");
    onFileUpload();
  }

  const onUpload = async (e) => {
    //const base64 = await convertToBase64(e.target.files[0]);
    //setFile(base64);
    console.log("");
  };
  //<section className="drag-drop" style={{ width: width, height: height }}>
  return (
    <section className="drag-drop" style={{ width: width }}>
      <div
        className={`document-uploader ${
          files.length > 0 ? "upload-box active" : "upload-box"
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
        onClick={(event) => {
          //event.preventDefault();
          fileInputRef.current.click();
        }}
      >
        <>
          <div className="upload-info">
            <AiOutlineCloudUpload />
            <div>
              <p>Arrastra y suelta las imagenes aqui</p>
              <p>
                Limitado a 1MB por archivo. <br />
                4 Archivos maximo.
                <br />
                Archivos soportados: .PNG, .JPG, .JPEG, .WEBP
              </p>
            </div>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            hidden
            id="browse"
            onChange={handleFileChange}
            accept=".png,.jpg,.jpeg,.webp"
            multiple
          />
          <label htmlFor="browse" className="browse-btn">
            Seleccionar archivos
          </label>
        </>

        <div
          className=""
          style={{
            width: "100%",
            display: "flex",
            /* overflow: hidden; */
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            alignContent: "space-between",
            rowGap: "10px",
          }}
        >
          {files.map((file, index) => (
            //{files.length > 0 && ( className={`${profile_img_only_username} ${profile_img_only_profile}`}

            <div
              className={`profile flex justify-center ${tooltipStyles.tooltip} container_image`}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <label htmlFor="profile">
                <img
                  className="profile_img_only_username profile_img_only_profile"
                  style={{
                    height: "100px",
                    width: "100px",
                    objectFit: "contain",
                  }}
                  src={file.cached}
                  alt="avatar"
                />
              </label>

              <span className={`${tooltipStyles.tooltiptext}`}>
                {file.name}
              </span>

              <div
                className="container_image_on"
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoveFile(index);
                }}
              >
                <IoCloseSharp
                  style={{ width: "33%", height: "33%", color: "white" }}
                />
              </div>

              <input
                onChange={onUpload}
                type="file"
                id="profile"
                name="profile"
              />
            </div>
          ))}
        </div>

        {/*files.length > 0 && (
          <div className="file-list">
            <div className="file-list__container">
              {files.map((file, index) => (
                <div className="file-item" key={index}>
                  <div className="file-info">
                    <p>{file.file.name}</p>
                    {/* <p>{file.type}</p> /}
                  </div>
                  <div className="file-actions">
                    <MdClear onClick={() => handleRemoveFile(index)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )*/}

        {/* <button type="button" onClick={(e) => saveAddress(e)}>
          Guardar
        </button> */}

        {files.length > 0 && (
          <div className="success-file">
            <AiOutlineCheckCircle style={{ color: "white", marginRight: 1 }} />
            <p>{files.length} archivo(s) seleccionado</p>
          </div>
        )}
      </div>
    </section>
  );
});

export default DragNdrop;

/*
import React, { useEffect, useState } from "react";
import { AiOutlineCheckCircle, AiOutlineCloudUpload } from "react-icons/ai";
import { MdClear } from "react-icons/md";
import "./drag-drop.css";
import avatar from "../../../assets/profile.png";
import { pagoniTest } from "helper/helper";

const DragNdrop = ({ onFilesSelected, width, height }) => {
  const MAX_FILE_SIZE = 5242880;
  const [files, setFiles] = useState([]); //useState<File[]>([]);

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles && selectedFiles.length > 0) {
      const newFiles = Array.from(selectedFiles);
      filterFiles(newFiles);
    }
  };
  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length > 0) {
      const newFiles = Array.from(droppedFiles);
      //setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      filterFiles(newFiles);
    }
  };

  const fileToCache = (file) => {
    return { file, cached: URL.createObjectURL(file) };
  };

  const filterFiles = (newFiles) => {
    const cachedNewFiles = newFiles.map((file) => fileToCache(file));

    const MAX_FILE_SIZE = 4;
    let wholeFiles = [...files, ...cachedNewFiles];
    const size =
      wholeFiles.length > MAX_FILE_SIZE ? MAX_FILE_SIZE : wholeFiles.length;
    wholeFiles = wholeFiles.slice(0, size);
    setFiles(wholeFiles);
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // On file upload (click the upload button)
  const onFileUpload = async () => {
    // Create an object of formData
    const formData = new FormData();

    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      formData.append("ProductName", Date.now().toString());
      formData.append("ImageFile" /*Date.now().toString()*, file, file.name);

      formData.append(
        "JsonData",
        `{ "Id": 123, "Nombre": "Dummy Description", "CreditoMinimo": 1234.33, "CreditoMaximo": 76.43, "Activo": true }`
        //`{ "name": "Dummy Name", "description": "Dummy Description" }`
      );
    }

    const data = JSON.stringify({
      description: "description",
    });
    // const fd = new FormData();
    // append directly as part of the postData in plain text
    //--formData.append("data", data);

    // Update the formData object
    /*formData.append(
      "json",
      this.state.selectedFile,
      this.state.selectedFile.name
    );*/

// Details of the uploaded file
//console.log(this.state.selectedFile);

// Request made to the backend api
// Send formData object
/*let posi = await axios.post("/api/products", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });*
    pagoniTest(formData);

    //
    /*const formData1 = new FormData();

    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      formData1.append(
        "productToAdd[" + index + "].ProductName",
        Date.now().toString()
      );
      formData1.append(
        "productToAdd[" + index + "].ImageFile",
        file,
        file.name
      );*/

/* formData1.append(
        "JsonData",
        `{ "Id": 123, "Nombre": "Dummy Description", "CreditoMinimo": 1234.33, "CreditoMaximo": 76.43, "Activo": true }`
        //`{ "name": "Dummy Name", "description": "Dummy Description" }`
      );*

    //pagoniTest22(formData1);
    //}
    //

    console.log("");
  };

  useEffect(() => {
    onFilesSelected(files);
  }, [files, onFilesSelected]);

  function saveAddress(event) {
    console.log("-->");
    onFileUpload();
  }

  const onUpload = async (e) => {
    //const base64 = await convertToBase64(e.target.files[0]);
    //setFile(base64);
    console.log("");
  };

  return (
    <section className="drag-drop" style={{ width: width, height: height }}>
      <div
        className={`document-uploader ${
          files.length > 0 ? "upload-box active" : "upload-box"
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <>
          <div className="upload-info">
            <AiOutlineCloudUpload />
            <div>
              <p>Arrastra y suelta las imagenes aqui</p>
              <p>
                Limitado a 1MB por archivo. <br />
                4 Archivos maximo.
                <br />
                Archivos soportados: .PNG, .JPG, .JPEG, .WEBP
              </p>
            </div>
          </div>
          <input
            type="file"
            hidden
            id="browse"
            onChange={handleFileChange}
            accept=".png,.jpg,.jpeg,.webp"
            multiple
          />
          <label htmlFor="browse" className="browse-btn">
            Seleccionar archivos
          </label>
        </>

        <div
          className=""
          style={{
            width: "100%",
            display: "flex",
            /* overflow: hidden; *
            "flex-wrap": "wrap",
            "justify-content": "space-evenly",
            "align-content": "space-between",
            "row-gap": "10px",
          }}
        >
          {files.map((file, index) => (
            //{files.length > 0 && ( className={`${profile_img_only_username} ${profile_img_only_profile}`}

            <div
              className="profile flex justify-center"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <label htmlFor="profile">
                <img
                  className="profile_img_only_username profile_img_only_profile"
                  style={{ height: "100px", width: "100px" }}
                  src={file.cached}
                  alt="avatar"
                />
              </label>

              <input
                onChange={onUpload}
                type="file"
                id="profile"
                name="profile"
              />
            </div>
          ))}
        </div>

        {files.length > 0 && (
          <div className="file-list">
            <div className="file-list__container">
              {files.map((file, index) => (
                <div className="file-item" key={index}>
                  <div className="file-info">
                    <p>{file.file.name}</p>
                    {/* <p>{file.type}</p> *}
                  </div>
                  <div className="file-actions">
                    <MdClear onClick={() => handleRemoveFile(index)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <button type="button" onClick={(e) => saveAddress(e)}>
          Guardar
        </button>

        {files.length > 0 && (
          <div className="success-file">
            <AiOutlineCheckCircle
              style={{ color: "#6DC24B", marginRight: 1 }}
            />
            <p>{files.length} archivo(s) seleccionado</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default DragNdrop;

*/
